import { useEffect, useState, useSyncExternalStore } from "react";
import { Alert, Box, Button, LinearProgress, Snackbar } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { getProofStatus, subscribeProofStatus } from "assets/pow";

export default function ProofStatus() {
    const { t } = useTranslation();
    const status = useSyncExternalStore(subscribeProofStatus, getProofStatus);
    // Snackbar keeps rendering its children during the closing animation.
    // Retain the last visible message so successful "idle" never becomes an error.
    const [lastVisibleStatus, setLastVisibleStatus] = useState(status);
    useEffect(() => {
        if (status.state !== "idle") setLastVisibleStatus(status);
    }, [status]);
    const visibleStatus = status.state === "idle" ? lastVisibleStatus : status;
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        if (!visibleStatus.retryAt) return;
        const timer = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(timer);
    }, [visibleStatus.retryAt]);
    const remaining = Math.max(0, Math.ceil(((visibleStatus.retryAt || 0) - now) / 1000));
    const working = visibleStatus.state === "working";
    const message = working ? "working" : visibleStatus.code === "pow_rate_limited" ? "rateLimited"
        : visibleStatus.code === "pow_unavailable" ? "unavailable" : "failed";
    return <Snackbar open={status.state !== "idle"} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
        <Alert severity={working ? "info" : "warning"} sx={theme => ({
            width: "100%", maxWidth: 560,
            ...(working && {
                bgcolor: theme.palette.background.paper,
                backgroundImage: `linear-gradient(${alpha(theme.palette.primary.main, 0.08)}, ${alpha(theme.palette.primary.main, 0.08)})`,
                color: theme.palette.text.primary,
                border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                "& .MuiAlert-icon": { color: theme.palette.primary.dark },
            }),
        })}
            action={!working && <Button color="inherit" size="small" disabled={remaining > 0}
                onClick={() => window.location.reload()}>{t("proof.retry")}</Button>}>
            <Box role="status" aria-live="polite">{t("proof." + message, { count: remaining })}</Box>
            {working && <LinearProgress sx={{ mt: 1 }} />}
        </Alert>
    </Snackbar>;
}
